import { ViewTypesNames } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getReturnViewNotificationCounts = {
  name: "getReturnViewNotificationCounts" as const,
  input: z.object({
    viewIds: z.array(z.string()).default([]),
    type: z.union([
      z.literal(ViewTypesNames.RETURNS),
      z.literal(ViewTypesNames.CLAIMS),
      z.literal(ViewTypesNames.WARRANTIES),
      z.literal(ViewTypesNames.RECYCLE),
    ]),
  }),
  output: z.object({ counts: z.record(z.string(), z.number()) }),
};
